export default {
    "VUE_APP_VERSION": "5.0.8.0",
	"VUE_APP_LMS_NAME": "Dev Cineworld",
    "VUE_APP_BASE_URL": "https://devcineworld.academypoint.net/",
    "VUE_APP_API_URL": "https://devcineworldapi.academypoint.net/",
    "VUE_APP_CDN_URL": "https://devcineworldcdn.academypoint.net/",
    "VUE_APP_ACADEMY_ADMIN_URL": "https://devcineworld.academypoint.co.net/Admin",
	"VUE_APP_ROUTER_MODE": "history",
	"VUE_APP_STORAGE": "sessionStorage",
	"VUE_APP_COLLECT_LOCATION_INFO": 0,
    "VUE_APP_TERMS_AND_CONDITIONS_URL" : "https://devcineworldapi.academypoint.net/data/SiteDocuments/{{currentSite}}/{{userLang}}/termsAndConditions.pdf",
    "VUE_APP_PDP_GUIDE_URL": "https://devcineworldapi.academypoint.net/data/SiteDocuments/{{currentSite}}/{{userLang}}/PdpGuide.pdf",
	"VUE_APP_HOME_PAGE_MODULESLIDER_CONTENT_TAG_CODE_CW": "OurVision",
    "VUE_APP_HOME_PAGE_MODULESLIDER_CONTENT_TAG_CODE_PH": "OurVision1",
	"VUE_APP_PROFILE_IMAGE_SIZE_MB": 5,
	"VUE_APP_SCORM_RESULT_DELAY": 3000,
	"VUE_APP_FALLBACK_LANG": "en-GB",
	"VUE_APP_RAYGUN_ENABLE_CRASHREPORTING": false,
	"VUE_APP_RAYGUN_ENABLE_PULSE": false,
	"VUE_APP_RAYGUN_API_KEY": "",
	"VUE_APP_USE_CLIENT_ROUTER": true,
    "VUE_APP_MAIN_WEBSITE": "cineworld",
    "VUE_APP_SUB_WEBSITES": ["picturehouse"],
	"VUE_APP_OPENID": 
	{
		"REDIRECT_URI":"https://devcineworld.academypoint.net/oidc-callback",
		"SILENT_REDIRECT_URI": "https://devcineworld.academypoint.net/silent-renew-oidc.html",
		"POST_LOGOUT_REDIRECT_URI": "https://devcineworld.academypoint.net/oidc-loggedout",
		"AUTHORITY": "https://devcineworldapi.academypoint.net",
		"CLIENT_ID": "Cirrus.AcademyPointAPI",
		"RESPONSE_TYPE": "code",
		"SCOPE": "openid email profile offline_access",
		"ACCESSTOKENEXPIRINGNOTIFICATIONTIME": 60,
		"CLOCKSKEW": 300,
		"AUTOMATICSILENTRENEW": true,
		"SILENTREQUESTTIMEOUT": 10000,
		"MONITORSESSION": true,
		"CHECKSESSIONINTERVAL": 2000,
		"STALESTATEAGE": 300,
		"LOADUSERINFO": false,
		"LOGGING": true,
		"EXEC_PROVIDERLOGOUT": true,
		"STORAGE": "sessionStorage"

	}
}